<template>
	<div>
		<el-collapse>
		  <el-collapse-item v-for="(item,index) in list" :name="index">
			  <template slot="title">
				  <div class="flex">
					  <h3 class="mr-4"> {{item.nickname+'/'+item.phone_number}}</h3>
					  <h3 class="mr-4">登录次数共计：{{item.login_times}}</h3>
					  <h3 class="mr-4">ip数共计：{{item.ip_times}}</h3>
					  <h3 class="">设备数共计：{{item.sb_times}}</h3>
				  </div>
			      
			  </template>
		    
			<p class="sub-title"><h3><u>登录ip记录</u></h3></p>
			<el-table :data="item.ip_list" style="width: 100%;">
				<el-table-column label="ip" prop="ip">
				</el-table-column>
				<el-table-column label="服务器ip" prop="server_ip">
				</el-table-column>
				<el-table-column label="登录时间" prop="created_at">
				</el-table-column>
				<el-table-column label="详情">
					<template slot-scope="scope">
						<div v-if="scope.row.info != '0'">
							<span>城市：{{JSON.parse(scope.row.info).country}}-{{JSON.parse(scope.row.info).city}}</span>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<p class="sub-title"><h3><u>登录设备记录</u></h3></p>
			<el-table :data="item.sb_list" style="width: 100%;">
				<el-table-column label="详情" prop="agent" width="800">
				</el-table-column>
				<el-table-column label="登录时间" prop="created_at">
				</el-table-column>
			</el-table>
		  </el-collapse-item>
		</el-collapse>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				pagination: {
					page: 1,
					per_page: 10,
				},
				list: [],
				total: 0
			}
		},
		methods: {
			getList() {
				this.$axios.get('admin-get-abnormal-users', this.pagination).then(res => {
					if (!res.code) {
						this.$message.error('列表获取失败')
						return
					}
					this.list = res.data;
					// this.total = res.data.total;
				});
			}
		},
		mounted() {
			this.getList()
		}
	}
</script>

<style scoped >
	.flex{
		display: flex;
	}
	.mr-2{
		margin-right: 8px;
	}
	.mr-4{
		margin-right: 16px;
	}
</style>
